import React from 'react';
import { useState } from 'react';
import { useEffect } from 'react';
import { useHistory } from "react-router-dom";
import { Table, Button, Modal } from 'antd';
import API from "../../Services/BaseService";
import Loading from "../../Component/Loading/Loading";
import { useSelector, useDispatch } from 'react-redux';
import URpostCarById from '../../Container/URpostCar/URpostCar';
import UrCarAction from '../../Container/UrCar/UrCarAction';
import { set } from 'react-hook-form';
import CommonPopup from '../../Component/CommonPopup/CommonPopup';
import "../../Component/CommonPopup/commonPopup.css";
import PageNotFound from '../FallBackUI/PageNotFound';
import DealerAction from '../DealerRedux/DealerAction';
import ls from 'local-storage';
import Pagination from "../Pagination";
import _ from 'lodash';
import moment from 'moment';
import appstore from '../../assets/img/appstore.png';
import googleplay from '../../assets/img/googleplay.png';
const URpostList = (item) => {

    const pageLimit = 10;

    const history = useHistory();
    const dispatch = useDispatch();
    const [loading, setLoading] = useState(true);
    const [urPostList, setUrPostList] = useState("");
    const [isModalVisible, setIsModalVisible] = useState(false);
    const successData = useSelector(state => state.LoginReducer.payload);
    const dealerData = useSelector(state => state.DealerReducer.payload);
    const [carsDetailsById, setCarsDetailsById] = useState(null);
    const [privilegeDetails, setPrivilegeDetails] = useState("");
    const [pay, setPay] = useState("");
    const [dealerList, setDealerList] = useState("");
    const [sellerList, setSellerList] = useState("");
    const [dealerId, setDealerId] = useState("");
    const [selectedSellerDetails, setSelectedSellerDetails] = useState("");
    const [selectSellerId, setselectSellerid] = useState("");
    console.log("selectSellerId", selectSellerId)
    const [flagFilter, setFalgFilter] = useState(false);

    const [isOpenPrivileges, setIsOpenPrivileges] = useState(false);
    const [popupTitle, setPopupTitle] = useState("");
    const [popupMsg, setPopupMsg] = useState("");
    const [popupType, setPopupType] = useState("");
    const [popupActionType, setPopupActionType] = useState("");
    const [popupActionValue, setPopupActionValue] = useState("");
    const [popupActionPath, setPopupActionPath] = useState("");

    const [errors, setErrors] = useState("");
    const [errorFlag, setErrorFlag] = useState(false);
    const [dealername, setDealerName] = useState("");
    const [color, setColor] = useState([]);
    const sellerStandingStatus = ls.get("sellerStandingStatus");
    console.log("check the login details", sellerStandingStatus);

    //pagination 
    const [URpostList, setURpostList] = useState("");
    const [currentPage, setCurrentPage] = useState(ls.get("currentpageopen") || 1);

    /* const [searchFlag1, setSearchFlag1] = useState(false); */
    const [totalRecords, setTotalRecords] = useState(0);
    const [totalPages, setTotalPages] = useState(1);

    const handlePages = (page) => {
        ls.set("currentpageopen", page)
        setCurrentPage(page)

    }


    const handlePageChangeDebounced = _.debounce(() => {

        fetchURpostList();


    }, 300);




    useEffect(() => {

        handlePageChangeDebounced();
        console.log("checking if in useEffect");
        return () => {
            handlePageChangeDebounced.cancel();
        };

    }, [currentPage]);


    const handlePageChange = (newPage) => {
        setCurrentPage(newPage);

    };

    const togglePopup = () => {
        setIsOpenPrivileges(!isOpenPrivileges);
    }

    const getPostCarPrivileges = () => {
        togglePopup()
        setPopupMsg("Seller doesn't have Post Car Privilege");
        setPopupActionType("close");
        setPopupActionValue("ok");
    }

    const getPayment = () => {
        togglePopup()
        setPopupMsg("Seller Need to Add Bank Account");
        setPopupActionType("close");
        setPopupActionValue("ok");
    }

    useEffect(() => {
        privileges(dealerData);
    }, [dealerData]);


    const columns = [

        // {
        //     title: 'Image',
        //     dataIndex: 'sellerimage',
        //     // key: 'address',
        // },

        {
            title: 'Seller #',
            dataIndex: ['seller_id', 'color'],
            render: (item, color) =>
                <div className={color.color != "" ?
                    color.color == "pink"
                        ? "tableRowPink "
                        : color.color == "Silver"
                            ? "tableRowSilver "
                            : color.color == "Orange"
                                ? "tableRowOrange "
                                : color.color == "Navy blue"
                                    ? "tableRowNavyBlue "
                                    : color.color == "firered"
                                        ? "tableRowFireRed "
                                        : color.color == "Purple"
                                            ? "tableRowPurple "
                                            : color.color == "Yellow"
                                                ? "tableRowYellow1 "
                                                : color.color == "green"
                                                    ? "tableRowGreenColor "
                                                    : color.color == "blue"
                                                        ? "tableRowBlue "
                                                        : color.color == "darkred"
                                                            ? "tableRowRed1"
                                                            : color.color == "black"
                                                                ? "tableRowBlack1"
                                                                : "" : ""}>{color.seller_id}</div>,
        },

        {
            title: 'Seller Name',
            dataIndex: 'seller_name',
            // key: 'address',
        },

        {
            title: 'No of Cars',
            dataIndex: 'no_cars',
            // key: 'address',
        },

        {
            title: 'Address',
            dataIndex: 'address',
            // key: 'address',
        },

        {
            title: 'State',
            dataIndex: 'state_name',
            // key: 'address',
        },
        {
            title: 'City',
            dataIndex: 'city_name',
            // key: 'address',
        },
        {
            title: 'Zipcode',
            dataIndex: 'zipcode',
            // key: 'address',
        },

        {
            title: 'Action',
            dataIndex: 'seller_info_id',
            render: (seller_info_id) => <Button onClick={() => URpostCarsDetailsById(seller_info_id)}>View </Button>
        },

    ];

    const URpostCarsDetailsById = (data) => {
        console.log("mydat==", data)
        setCarsDetailsById(data)
        showModal()

    }
    const handleSellerDetailsName = (e) => {

        setDealerId(e.target.value)
        console.log("=========check seller details name", e.target.value)
        setSelectedSellerDetails(dealerList.filter(data => data.seller_dealer_id == e.target.value)[0])
        console.log("=========check", dealerList.filter(data => data.seller_dealer_id == e.target.value))
        const selectedSellerDetails = dealerList.filter(data => data.seller_dealer_id == e.target.value)[0];
        searchCarDetail(selectedSellerDetails)
        setselectSellerid(selectedSellerDetails.seller_dealer_id)
        setFalgFilter(true)
        dispatch(DealerAction.searchrequest(selectedSellerDetails));
    }

    useEffect(() => {
        if (dealerData !== null) {

            searchCarDetail(dealerData);
        }
    }, [])


    const getDealername = (data) => {

        let request = {
            seller_id: successData.seller_id,
            seller_token: successData.seller_token,
        }
        API.post("dealerNameDynamic/condition", request).then(response => {
            if (response.data.success === true) {


                setDealerList(response.data.data);

            }

            else {
                setErrors(response.data.error.name)
                setErrorFlag(true)
            }


        })
            .catch(function (error) {
                if (error.response) {
                    setErrors(error.response.data.error)
                    setErrorFlag(true)
                }
            });
    }

    useEffect(() => {
        getDealername();

    }, []);

    useEffect(() => {
        if (isModalVisible) {

        }
    }, [isModalVisible])

    const showModal = () => {
        setIsModalVisible(true);
    };

    const handleOk = () => {
        setIsModalVisible(false);
        // setCarsDetailsById(null)
    };

    const handleCancel = () => {
        setIsModalVisible(false);
        // setCarsDetailsById(null) 
    };

    function onHandleView(e) {
        console.log("IDDDDDDDDDD", e)
        URpostCarsDetailsById(e.seller_info_id)
    }


    async function fetchURpostList(data) {
        console.log("inside fn");
        console.log("hiiiiiiiiiiii", successData.seller_dealer_id)
        let request = {
            // seller_dealer_id:  data == undefined ?dealerData !== null ? dealerData.seller_dealer_id: successData.seller_dealer_id :data,
            seller_dealer_id: data == undefined || data === null ? successData.seller_dealer_id : data.seller_dealer_id,

            seller_id: successData.seller_id,
            seller_token: successData.seller_token


        };
        const state = API.post('urpostList/condition', request);
        state.then(res => {
            console.log("res", res)
            if (res.data.success === true) {
                setUrPostList(res.data.data);
                setDealerName(res.data.data[0]?.dealer_name);
                const endIndex = currentPage * pageLimit;
                const startIndex = endIndex - pageLimit;
                const records = res.data.data.slice(startIndex, endIndex)
                setURpostList(records);
                setTotalPages(Math.ceil(res.data.data.length / 10));
                setTotalRecords([...Array(Math.ceil(res.data.data.length / 10) + 1).keys()].slice(1))
                setLoading(false);
            }
            else {
                setErrors(res.data.error)
                setErrorFlag(true)
            }
        })
            .catch(function (error) {
                if (error.response) {
                    setErrors(error.response.data.error)
                    setErrorFlag(true)
                }
            });
    }

    const paginationConfig = {
        pageSize: 10, // number of rows per page
        current: 1, // current page number
        total: urPostList.length, // total number of items
    };

    const searchCarDetail = (data) => {

        let request = {
            seller_dealer_id: data.seller_dealer_id,
            seller_id: successData.seller_id,
            seller_token: successData.seller_token

        };

        API.post("urpostListFilter/condition", request)
            .then((res) => {
                console.log("res", res.data.data)
                if (res.data.success === true) {
                    setUrPostList(res.data.data);
                    console.log("setUrPostList123", res.data.data)
                    setTotalPages(Math.ceil(res.data.data.length / 10));
                    setTotalRecords([...Array(Math.ceil(res.data.data.length / 10) + 1).keys()].slice(1))
                }
                else {
                    setErrors(res.data.error)
                    setErrorFlag(true)
                }
            })
            .catch(function (error) {
                if (error.response) {
                    setErrors(error.response.data.error)
                    setErrorFlag(true)
                }
            });
    }

    const allredirectpage = (seller_info_id) => {
        console.log("seller_dealer_id+++++", seller_info_id)
        // dispatch(UrCarAction.sellerid(successData.seller_dealer_id))
        setIsModalVisible(true);
        history.push("/urpostcarbyid/" + seller_info_id);
    }

    useEffect(() => {
        fetchURpostList(dealerData);
        privileges(dealerData);
        paymentPopup(dealerData);
    }, [dealerData]);

    const privileges = (data) => {
        let request = {
            seller_dealer_id: data == undefined || data === null ? successData.seller_dealer_id : data.seller_dealer_id,
            seller_id: successData.seller_id,
            seller_id: successData.seller_id, seller_token: successData.seller_token
        }
        API.post("sellerPrivileges/condition", request)
            .then((response) => {
                console.log("privilege", response.data.data[0])
                if (response.data.success === true) {
                    setPrivilegeDetails(response.data.data[0])

                }
                else {
                    setErrors(response.data.error)
                    setErrorFlag(true)
                }
            })
            .catch(function (error) {
                if (error.response) {
                    setErrors(error.response.data.error)
                    setErrorFlag(true)
                }
            });
    }

    const paymentPopup = (data) => {
        let request = {
            // seller_dealer_id: data == undefined ?dealerData !== null ? dealerData.seller_dealer_id: successData.seller_dealer_id :data,
            seller_dealer_id: data == undefined || data === null ? successData.seller_dealer_id : data.seller_dealer_id,

            seller_id: successData.seller_id,
            seller_id: successData.seller_id, seller_token: successData.seller_token
        }
        API.post("defaultsellerpaymentinfo/condition", request)
            .then((response) => {
                console.log("privilege", response.data.data[0])
                if (response.data.success === true) {
                    setPay(response.data.data[0])
                }
                else {
                    setErrors(response.data.error)
                    setErrorFlag(true)
                }
            })
            .catch(function (error) {
                if (error.response) {
                    setErrors(error.response.data.error)
                    setErrorFlag(true)
                }
            });
    }

    function formatTime(value) {
        if (value == null || value == undefined || value == "null" || value == "undefined") {
            return value
        }
        else {
            let local = new Date(value);
            let offset = local.getTimezoneOffset();
            value = new Date(local.getTime() - offset * 60000);
            value = moment(value).format('MMMM D, YYYY hh:mm A');
            return value;
        }
    }

    return (
        <div>
            <main id="main" className="inner-page">

                {errorFlag === true ? <PageNotFound error={errors} /> :
                    <section class="section" >
                        <div id="fees">
                            <div class="container-fluid inner-page-space">
                                <div class="common-heading">
                                    <div className="row">
                                        <div className="col-lg-4">
                                            <div class="back-btn">
                                                <a class="back-btn-primary" onClick={() => history.push("/carlist")}>
                                                    <i class="bx bx-chevron-left"></i> Back
                                                </a>
                                            </div>
                                        </div>

                                        <div className="col-lg-4">
                                            <div class="title">
                                                <p class="inner-title">URpost List</p>
                                            </div>
                                        </div>



                                        <div className="col-lg-4">

                                            <div class="title-dropdown">
                                                <select id="drop" placeholder="" className={`${dealerData != null ? (dealerData?.color == "pink"
                                                    ? "tableRowPink  form-control box"
                                                    : dealerData?.color == "firered"
                                                        ? "tableRowFireRed  form-control box"
                                                        : dealerData?.color == "green"
                                                            ? "tableRowGreenColor form-control box"
                                                            : dealerData?.color == "darkred"
                                                                ? "tableRowRed1  form-control box"
                                                                : " form-control box") :
                                                    (dealerList[0]?.color == "pink"
                                                        ? "tableRowPink  form-control box"
                                                        : dealerList[0]?.color == "firered"
                                                            ? "tableRowFireRed  form-control box"
                                                            : dealerList[0]?.color == "green"
                                                                ? "tableRowGreenColor form-control box"
                                                                : dealerList[0]?.color == "darkred"
                                                                    ? "tableRowRed1  form-control box"
                                                                    : " form-control box")
                                                    }`} onChange={handleSellerDetailsName}>
                                                    {dealerData != null ?
                                                        <option value={null} style={{ "display": "none" }}>{dealerData.dealer_name}({dealerData?.seller_dealer_id})</option> :
                                                        <option value={null} style={{ "display": "none" }}>{dealerList[0]?.dealer_name}({dealerList[0]?.seller_dealer_id})</option>}
                                                    {dealerList.length > 0 &&
                                                        <>
                                                            {dealerList.map((dealerList, index) => <option className={dealerList?.color == "pink"
                                                                ? "tableRowPink  user_name"
                                                                : dealerList?.color == "Silver"
                                                                    ? "tableRowSilver  user_name"
                                                                    : dealerList?.color == "Orange"
                                                                        ? "tableRowOrange  user_name"
                                                                        : dealerList?.color == "Navy blue"
                                                                            ? "tableRowNavyBlue  user_name"
                                                                            : dealerList?.color == "firered"
                                                                                ? "tableRowFireRed  user_name"
                                                                                : dealerList?.color == "Purple"
                                                                                    ? "tableRowPurple  user_name"
                                                                                    : dealerList?.color == "Yellow"
                                                                                        ? "tableRowYellow1  user_name"
                                                                                        : dealerList?.color == "green"
                                                                                            ? "tableRowGreenColor user_name"
                                                                                            : dealerList?.color == "blue"
                                                                                                ? "tableRowBlue  user_name"
                                                                                                : dealerList?.color == "darkred"
                                                                                                    ? "tableRowRed1  user_name"
                                                                                                    : dealerList?.color == "black"
                                                                                                        ? "tableRowBlack1 user_name"
                                                                                                        : " user_name"} key={dealerList.seller_dealer_id} value={dealerList.seller_dealer_id}  >{dealerList.dealer_name}({dealerList?.seller_dealer_id})</option>)}
                                                        </>
                                                    }
                                                </select>


                                            </div>


                                        </div>




                                    </div>
                                </div>
                                <div className='row'>
                                    <div className='col-lg-4'>

                                    </div>
                                    <div className='col-lg-4'>

                                    </div>
                                    <div className='col-lg-4'>
                                        <div class="add-floor">
                                            <Button className="add-user-btns"
                                                onClick={() => !(sellerStandingStatus === 5 || sellerStandingStatus === 6 || sellerStandingStatus === 7) && (privilegeDetails?.post_car == 0 ? getPostCarPrivileges() : history.push({ pathname: "/urpost", state: { flagFilter: flagFilter, selectSellerId: selectSellerId } }))}
                                                disabled={sellerStandingStatus === 5 || sellerStandingStatus === 6 || sellerStandingStatus === 7}><i className="icofont-plus"></i> Add</Button>
                                        </div>
                                    </div>
                                </div>


                                {/* <div className="col-lg-12">
                                        <div class="table-responsive">
                                            <div class="urposttable">

                                                {loading ? <Loading /> :
                                                    <Table columns={columns} dataSource={urPostList}

                                                        pagination={{
                                                            pageSize: 10,
                                                        }}
                                                        size="small"
                                                 
                                                    >
                                                    </Table>}

                                            </div>
                                        </div>
                                    </div> */}
                                {loading ? <Loading /> :
                                    <div class="sellerChargesListtable table-responsive">
                                        <div className="abletable">
                                            <table>
                                                <thead>
                                                    <tr>
                                                        {/* <th className="">Charges #</th> */}
                                                        <th className="">Seller #</th>
                                                        <th className="">Seller Name</th>
                                                        <th className="">No of Cars</th>
                                                        <th className="">Address</th>
                                                        <th className="">State</th>
                                                        <th className="">City</th>
                                                        <th className="">Zipcode</th>
                                                        <th className="">Date & Time</th>
                                                        <th className="buyercha-action">Action</th>
                                                    </tr>
                                                </thead>

                                                {/* {sellerChargeList.length > 0 ? sellerChargeList.map((item) => */}
                                                {URpostList.length > 0 ? URpostList.map((item) =>

                                                    <tr>

                                                        <td className={item.color != "" ?
                                                            item.color == "pink"
                                                                ? "tableRowPink "
                                                                : item.color == "Silver"
                                                                    ? "tableRowSilver "
                                                                    : item.color == "Orange"
                                                                        ? "tableRowOrange "
                                                                        : item.color == "Navy blue"
                                                                            ? "tableRowNavyBlue "
                                                                            : item.color == "firered"
                                                                                ? "tableRowFireRed "
                                                                                : item.color == "Purple"
                                                                                    ? "tableRowPurple "
                                                                                    : item.color == "Yellow"
                                                                                        ? "tableRowYellow1 "
                                                                                        : item.color == "green"
                                                                                            ? "tableRowGreenColor "
                                                                                            : item.color == "blue"
                                                                                                ? "tableRowBlue "
                                                                                                : item.color == "darkred"
                                                                                                    ? "tableRowRed1"
                                                                                                    : item.color == "black"
                                                                                                        ? "tableRowBlack1"
                                                                                                        : "" : ""}>{item.seller_id}</td>
                                                        <td>{item.seller_name}</td>
                                                        <td>{item.no_cars}</td>
                                                        <td>{item.address}</td>
                                                        <td>{item.state_name}</td>
                                                        <td>{item.city_name}</td>

                                                        <td>{item.zipcode}</td>
                                                        <td>{formatTime(item.date_tz)}</td>

                                                        <td className='action-right-fix-list' >
                                                            <Button className="ant-btn" onClick={() => onHandleView(item)}> View</Button>
                                                        </td>


                                                    </tr>
                                                ) :
                                                    <tr>
                                                        <td colspan="13" ng-show="0"><b>There's No Data</b></td>
                                                    </tr>
                                                }

                                            </table>
                                        </div>
                                    </div>
                                }
                            </div>

                        </div>
                    </section>
                }
                <div className="col-lg-12 tablePagination d-flex justify-content-center">
                    <Pagination currentPage={currentPage} totalPages={totalPages} onPageChange={handlePageChange} totalRecords={totalRecords} handlePages={handlePages} />
                </div>


                {carsDetailsById !== null && <Modal
                    centered
                    visible={isModalVisible}
                    onOk={handleOk}
                    onCancel={handleCancel}

                    footer={<Button type="primary" className="cta-btns" onClick={handleOk}>Ok</Button>}
                    width={1000}
                >
                    <URpostCarById carId={carsDetailsById} />
                </Modal>}



            </main>

            {isOpenPrivileges &&
                <CommonPopup
                    handleClose={togglePopup}
                    popupTitle={popupTitle}
                    popupMsg={popupMsg}
                    popupType={popupType}
                    popupActionType={popupActionType}
                    popupActionValue={popupActionValue}
                    popupActionPath={popupActionPath}
                />
            }
            <section id="playstoreBlock" className="playstoreBlock">
                <div className="container">


                    <div className="row content">
                        <div className="col-lg-12">
                            <img src={appstore} />
                            <img src={googleplay} />
                        </div>

                    </div>

                </div>
            </section>
        </div>
    );
};

export default URpostList;